import React from 'react';
import AdminHome from 'components/AdminHome';
import { getAllDashboards } from 'api/dashboards';
import { useQueries } from '@tanstack/react-query';
import Loader from 'components/Loader';
import { getAllUsers } from 'api/users';

export const dashboardAllQuery = () => ({
    queryKey: ['dashboards'],
    queryFn: async () => getAllDashboards(),
});

export const userAllQuery = () => ({
    queryKey: ['users'],
    queryFn: async () => getAllUsers(),
});

export default function Admin() {
    const [dashboardsQuery, usersQuery] = useQueries({
        queries: [dashboardAllQuery(), userAllQuery()],
    });

    const { data: dashboards, isLoading: isLoadingDashboards } = dashboardsQuery;
    const { data: users, isLoading: isLoadingUsers } = usersQuery;

    if (isLoadingDashboards || isLoadingUsers) return <Loader />;

    return (
        <div data-testid="route-admin-index">
            <AdminHome dashboards={dashboards} users={users} />
        </div>
    );
}
